import angular from "angular";

import ServiceProviderNotificationsModuleRouting from "./service-provider-notifications.module.routing";

export default angular
  .module("vt-service-provider-notifications", [])
  .config(ServiceProviderNotificationsModuleRouting);
